import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Select, TextField, Typography, Grid, FormControlLabel, Button} from "@mui/material";


export const MessageContainer = styled("div")`
    height: 78%;
    text-align: center;
    background: white;
    border-radius: .5em;
    position: relative;
    top: .5em;

`;

export const DownloadButton = styled("button")`
    height: 3em;
     color: white;
    background-color: #A100FF;
    border-radius: 20px;
    width: 18em;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    top: 5em;
    display: ruby;
`;

export const BackButton = styled("button")`
    height: 2em;
    color: #A100FF;
    background-color: transparent;
    border-radius: 20px;
    width: 6em;
    margin-left: auto;
    position: relative;
    top: .3em;
    right: .6em;
    border: 1px solid grey;
    margin-right: 1em;
    font-weight: 600;

    &:hover {
        border: 1px solid grey;
  }
`;


export const CloseButton = styled("button")`
    height: 2.5em;
    color: white;
    background-color: #000000;
    border-radius: 20px;
    width: 7em;
`;

export const FullContainer = styled("div")`
    height: 40em;
`;

export const ButtonContainer = styled("div")`
    display: flex;
    position: relative;
    top: .6em;
    padding-top: 1em;
`;